/** @format */

import { Tenant } from '@/@ducks/room/declarations';
import ColiverIcon from '@/assets/icons/dovevivo_colivers_icon.svg';
import { TTranslation } from '@/i18n/declarations';
import { useIntl } from 'gatsby-plugin-intl';
import React, { FC, memo } from 'react';
import { ColiverBoxContainer, ColiverBoxRoomNumber, ColiverBoxTitle, Ellipse } from './ColiverBox.style';

export const ColiverBox: FC<ColiverBoxProps> = memo(({ isThisRoom = false, room }) => {
  const { formatMessage } = useIntl();
  if (room.type === 'room') return null;
  const { job, age, gender, roomNumber } = room;
  return (
    <ColiverBoxContainer>
      <img role="presentation" src={ColiverIcon} />
      <div>
        <ColiverBoxRoomNumber>
          {isThisRoom && <Ellipse />}
          {formatMessage({ id: 'pdp.room_number' }, { room_number: roomNumber })}
        </ColiverBoxRoomNumber>
        <ColiverBoxTitle>
          {!!job ? formatMessage({ id: job.toLowerCase() as TTranslation }) : ''}
          {age > 0 && `, ${age}`}
          {gender && `, ${formatMessage({ id: gender.toLowerCase() as TTranslation })}`}
        </ColiverBoxTitle>
      </div>
    </ColiverBoxContainer>
  );
});

type ColiverBoxProps = {
  isThisRoom: boolean;
  room: Tenant;
};
